import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';
import { eocUserResource } from '@atlassian/eoc-resources';
import { routingRulesResource } from '@atlassian/eoc-routing-rules/resources';
import { useResource } from '@atlassian/eoc-rrr-helpers';
import {
	getScheduleRightsResource,
	getSchedulesResource,
	getScheduleTimeTemplatesResource,
	getUiPreferencesResource,
} from '@atlassian/eoc-schedule/resources';

import { getTeamResource } from '../../services/resources';

import { ErrorImage } from './error-image';
import { messages } from './messages';

const Error = () => {
	const intlApi = useIntl();
	const { refresh: getTeamRefresh, error: getTeamError } = useResource(getTeamResource);
	const { refresh: getScheduleTimeTemplatesRefresh, error: getScheduleTimeTemplatesError } =
		useResource(getScheduleTimeTemplatesResource);
	const { refresh: getScheduleRightsRefresh, error: getScheduleRightsError } =
		useResource(getScheduleRightsResource);
	const { refresh: getSchedulesRefresh, error: getSchedulesError } =
		useResource(getSchedulesResource);
	const { refresh: getUiPreferencesRefresh, error: getUiPreferencesError } =
		useResource(getUiPreferencesResource);
	const { refresh: eocUserRefresh, error: eocUserError } = useResource(eocUserResource);
	const { refresh: routingRulesRefresh, error: routingRulesError } =
		useResource(routingRulesResource);

	return (
		<EmptyState
			description={intlApi.formatMessage(messages.errorDescription)}
			header={intlApi.formatMessage(messages.errorTitle)}
			imageHeight={250}
			renderImage={() => <ErrorImage />}
			imageWidth={250}
			primaryAction={
				<Button
					appearance="primary"
					onClick={() => {
						getTeamError && getTeamRefresh();
						getScheduleRightsError && getScheduleRightsRefresh();
						getSchedulesError && getSchedulesRefresh();
						getUiPreferencesError && getUiPreferencesRefresh();
						getScheduleTimeTemplatesError && getScheduleTimeTemplatesRefresh();
						eocUserError && eocUserRefresh();
						routingRulesError && routingRulesRefresh();
					}}
				>
					{intlApi.formatMessage(messages.tryAgain)}
				</Button>
			}
		/>
	);
};

export { Error };
